<template>
  <div class="container">
    <div class="columns">
      <div class="column" v-for="(report, ridx) in reports" :key="ridx">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">{{ report.name }}</p>
            <button class="card-header-icon" aria-label="more options">
              <span class="icon">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </header>
          <div class="card-content">
            <div class="content">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              nec iaculis mauris.
              <a href="#">@bulmaio</a>. <a href="#">#css</a>
              <a href="#">#responsive</a>
              <br />
              <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
            </div>
          </div>
          <!-- <footer class="card-footer">
            <a href="#" class="card-footer-item">Save</a>
            <a href="#" class="card-footer-item">Edit</a>
            <a href="#" class="card-footer-item">Delete</a>
          </footer> -->
        </div>
      </div>
    </div>
    <generic-table
      ref="datatable"
      :title="$t('reports')"
      :columns="columns"
      :column_search="true"
      resource_url="/fel/bill/datatables"
      @data_loaded="draw_as_list"
      @init_complete="init_complete"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <billing-modal ref="emitter_modal" @success="refresh" :emitter_id="11" />
  <billing-viewer-modal ref="billing_viewer_modal" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_currency,
} from "@/utils";
import BillingModal from "../billing_modal/Index.vue";
import BillingViewerModal from "../billing_viewer_modal/Index.vue";

export default {
  name: "EmittersDatatable",
  components: { GenericTable, BillingModal, BillingViewerModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date_time(row.create_date) || "";
          },
        },
        {
          title: v.$t("emitter"),
          searchable: false,
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.emitter.name || "";
          },
        },
        {
          title: v.$t("nit"),
          name: "nit",
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.nit || "";
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("total"),
          name: "total",
          width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return (
              `${row.emitter.settings.settings.currency} ${row.total}` || ""
            );
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.billing_viewer_modal.show_modal(uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete bill?"),
                    v,
                    () => {
                      del("/fel/bill", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
      reports: [],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.emitter_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    init_complete(opts) {
      let v = this;
      let { settings, json } = opts;
      let layout_table = window.jQuery(".dt-layout-table");
      // layout_table.addClass("is-hidden");
    },
    draw_as_list(json) {
      let v = this;
      // console.log("draw", json);
      v.reports = json;
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
